module.exports = __webpack_public_path__ + "static/media/logo-Type-White.1704879a.svg";